import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {PaymentStore} from '../stores/payment.store';
import {RestaurantStore} from '../stores/restaurant.store';
import {SharedOrderService} from "../services/shared-order.service";

@Injectable({
  providedIn: 'root'
})
export class CustomerGuard implements CanActivate {
  constructor(
    private paymentStore: PaymentStore,
    private restaurantStore: RestaurantStore,
    private sharedOrderService: SharedOrderService
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.sharedOrderService.sharedOrderId$) {
      return true;
    }
    if (this.paymentStore.customer && this.paymentStore.customer?.squareCustomerId) {
      return true;
    }
    this.restaurantStore.backToStorePage(false, state.url);
  }
}
